import useFeedbackStore from '../store/useFeedbackStore';
import { invalidateAuthSession } from './AuthSession';

export const expireLocalSession = (
  rejectedToken,
  { reason = 'backend_401', source = 'api' } = {},
) => {
  const invalidated = invalidateAuthSession({
    reason,
    source,
    expectedToken: rejectedToken,
  });
  if (!invalidated) return false;
  useFeedbackStore.getState().showFeedback('Session expired. Please login again.', 'error');
  return true;
};
